<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} reserva
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body p-15">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off" class="m-b-50">
          <div id="accordion">
            <div class="card mb-0">
              <div class="card-header book__accordion__header" id="headingGeneral">
                <h5 class="mb-0 mt-0 font-14">
                  <a data-parent="#accordion" aria-controls="general" class="book__accordion__title">
                    <i class="fas fa-user m-r-5"></i>Datos generales
                  </a>
                </h5>
              </div>
              <div id="general" class="collapse show" aria-labelledby="headingGeneral" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label id="client_label">Cliente responsable <span class="required"></span>
                        <div class="book__nrodoc m-l-20" *ngIf="isClientSelected">
                          ( {{clientSelected.typeDocument}} : {{clientSelected.document}} )
                        </div>
                      </label>
                      <ng-container *ngIf="isClientSelected">
                        <div class="input-group">
                          <input type="text" class="form-control form-control-sm" disabled
                            value="{{clientSelected.fullname}}">
                          <div class="input-group-append bg-custom b-0 removeClient">
                            <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                              (click)="removeClient()">
                              <i class="fas fa-backspace w-100 f-s-12"></i>
                            </div>
                            <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                              data-toggle="modal" data-target="#openExtendsClient"
                              (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                              <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!isClientSelected">
                        <div class="input-group input-group-grid">
                          <component-search-client [classSize]="'search-small'"
                            (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                          </component-search-client>
                          <div class="input-group-append b-0">
                            <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                              data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                              <i class="fas fa-user-plus w-100"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Número teléfono <span class="required"></span></label>
                      <div class="input-group">
                        <input type="text" class="form-control form-control-sm" id="tel_1" formControlName="tel_1"
                          remove-spaces-number required placeholder="Tel 1">
                        <div class="input-group-append">
                          <div class="input-group-text p-l-2 p-r-2">-</div>
                        </div>
                        <input type="text" class="form-control form-control-sm" id="tel_2" formControlName="tel_2"
                          remove-spaces-number placeholder="Tel 2">
                      </div>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Origen reserva <span class="required"></span></label>
                      <select class="form-control form-control-sm" id="originBookingSelected"
                        formControlName="bookingorigin_id" required>
                        <option *ngFor="let item of originsbooking" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-2">
                      <label class="m-b-3">N° pax <span class="required"></span>
                        <div class="custom-control custom-checkbox float-right">
                          <input type="checkbox" class="custom-control-input" formControlName="is_reference_pax"
                            id="is_reference_pax">
                          <label class="custom-control-label f-s-10 p-t-3" for="is_reference_pax">¿Ref.?</label>
                        </div>
                      </label>
                      <input type="text" class="form-control form-control-sm" id="nro_pax" formControlName="nro_pax"
                        required numeric>
                    </div>
                    <ng-container *ngIf="item.value.is_reference_pax == true">
                      <div class="form-group col-lg-4">
                        <label>Referencia de pasajeros:</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text p-l-2 p-r-2 f-s-10">#Niños</div>
                          </div>
                          <input type="text" placeholder="N° niños" class="form-control form-control-sm"
                            id="nro_pax_childs" formControlName="nro_pax_childs" numeric>
                          <div class="input-group-append">
                            <div class="input-group-text p-l-2 p-r-2 f-s-10">#Adultos</div>
                          </div>
                          <input type="text" placeholder="N° adultos" class="form-control form-control-sm"
                            id="nro_pax_adults" formControlName="nro_pax_adults" numeric>
                          <div class="input-group-append">
                            <div class="input-group-text p-l-2 p-r-2 f-s-10">#Ancianos</div>
                          </div>
                          <input type="text" placeholder="N° ancianos" class="form-control form-control-sm"
                            id="nro_pax_olds" formControlName="nro_pax_olds" numeric>
                        </div>
                      </div>
                    </ng-container>
                    <div class="form-group col-lg-5">
                      <label><i class="fas fa-plane-arrival m-r-2"></i>Fecha llegada y Hora Llegada<span
                          class="m-l-70"></span>Fecha Salida <i class="fas fa-plane-departure m-l-2"></i></label>
                      <div class="input-group">
                        <input type="text" class="form-control form-control-sm" id="date_arrival"
                          formControlName="date_arrival">
                        <div class="input-group-append">
                          <div class="input-group-text p-l-2 p-r-2">-</div>
                        </div>
                        <div class="input-group-append">
                          <input type="time" class="form-control form-control-sm" formControlName="time_arrival"
                            id="time_arrival">
                        </div>
                        <div class="input-group-append">
                          <div class="input-group-text p-l-2 p-r-2">-</div>
                        </div>
                        <input type="text" class="form-control form-control-sm" id="date_departure"
                          formControlName="date_departure">
                      </div>
                    </div>
                    <div class="form-group col-lg-5">
                      <label>Llegada por <span class="m-l-130">Ref. datos llegada</span></label>
                      <div class="input-group">
                        <select class="form-control form-control-sm" id="arrivalPlaceSelected"
                          formControlName="arrivalplace_id">
                          <option *ngFor="let item of arrivalplaces" [ngValue]="item.id">{{ item.description }}</option>
                        </select>
                        <div class="input-group-append">
                          <div class="input-group-text p-l-2 p-r-2">-</div>
                        </div>
                        <input type="text" class="form-control form-control-sm" formControlName="arrival_place">
                      </div>
                    </div>
                    <!-- <div class="form-group col-lg-3">
                      <label>Ref. datos llegada</label>
                      <input type="text" class="form-control form-control-sm" formControlName="arrival_place">
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Asesor reserva
                        <ng-container *ngIf="employeeSelected == null">
                          (<span class="f-s-11">empleado</span>)
                        </ng-container>
                        <ng-container *ngIf="employeeSelected != null">
                          (<span class="f-s-11">{{employeeSelected.jobassigned}}</span>)
                        </ng-container>
                      </label>
                      <ng-container *ngIf="employeeSelected != null">
                        <div class="input-group">
                          <input type="text" class="form-control form-control-sm" disabled
                            value="{{employeeSelected.fullname}}">
                          <div class="input-group-append bg-custom b-0 removeClient">
                            <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                              (click)="removeEmployee()">
                              <i class="fas fa-backspace w-100 f-s-12"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="employeeSelected == null">
                        <component-search-employee [classSize]="'search-small'"
                          (selectedEmployeeEvent)="selectedEmployeeSearch($event)" class="w-100">
                        </component-search-employee>
                      </ng-container>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>N° ref. ó etiqueta</label>
                      <input type="text" class="form-control form-control-sm" formControlName="reference_voucher">
                    </div>
                    <!-- <div class="form-group col-lg-3">
                      <label>Contacto emergencia</label>
                      <input type="text" class="form-control form-control-sm" formControlName="contact_emergency">
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Tel. emergencia</label>
                      <input type="text" class="form-control form-control-sm" formControlName="telephone_emergency">
                    </div> -->
                    <div class="form-group col-lg-3">
                      <label>Grupo Trabajo</label>
                      <select class="form-control form-control-sm" id="workingGroupSelected"
                        formControlName="workinggroup_id">
                        <option value="null">Sin asignar</option>
                        <option *ngFor="let item of workinggroups" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Observaciones</label>
                      <input type="text" class="form-control form-control-sm" formControlName="observations">
                    </div>
                    <div class="form-group col-lg-3">
                      <div class="custom-control custom-checkbox float-left">
                        <input type="checkbox" class="custom-control-input" formControlName="is_book_hotel"
                          id="is_book_hotel">
                        <label class="custom-control-label p-t-3" for="is_book_hotel"><i
                            class="fas fa-hotel m-r-2"></i>¿Reserva solo hotel?</label>
                      </div>
                    </div>
                    <div class="form-group col-lg-3">
                      <div class="custom-control custom-checkbox float-left">
                        <input type="checkbox" class="custom-control-input" formControlName="is_favorite"
                          id="is_favorite">
                        <label class="custom-control-label p-t-3" for="is_favorite">¿Es favorito (reserva)?</label>
                      </div>
                    </div>
                    <div class="form-group col-lg-3" *ngIf="!item.value.is_book_hotel">
                      <div class="custom-control custom-checkbox float-left">
                        <input type="checkbox" class="custom-control-input" formControlName="is_itinerary"
                          id="is_itinerary" (change)="specifiedItinerary()">
                        <label class="custom-control-label p-t-3" for="is_itinerary">Especificar itinerario</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0" *ngIf="view_itinerary">
              <div class="card-body p-l-15 p-r-15 p-t-0">
                <div class="row">
                  <p class="form__group__title f-s-12 w-100"><i class="fas fa-info-circle m-r-3"></i>Datos importantes
                    para ficha de confirmación de reserva</p>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="form-group col-lg-6">
                        <label>Asociar paquete
                          <ng-container *ngIf="packagetourSelected != null">
                            (<span class="f-s-11">TIPO: {{packagetourSelected.typepackage.description}}</span>)
                          </ng-container>
                        </label>
                        <div class="row">
                          <div class="col-lg-4 p-r-0 box_import_package">
                            <select class="form-control bg-light">
                              <option value="">Importar paquete</option>
                            </select>
                          </div>
                          <div class="col-lg-8 p-l-0 box_import_package_selected">
                            <ng-container *ngIf="packagetourSelected != null">
                              <div class="input-group">
                                <input type="text" class="form-control form-control-sm" disabled
                                  value="{{packagetourSelected.description}}">
                                <div class="input-group-append bg-custom b-0">
                                  <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                    (click)="removePackagetour()">
                                    <i class="fas fa-backspace w-100 f-s-12"></i>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="packagetourSelected == null">
                              <component-search-packagetour [classSize]="'search-small'"
                                (selectedPackagetourEvent)="selectedPackagetourSearch($event)" class="w-100">
                              </component-search-packagetour>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <label>Nombre (título ficha) <span class="required"></span></label>
                        <input type="text" class="form-control" formControlName="title_itinerary">
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <ckeditor formControlName="itinerary"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0" *ngIf="!item.value.is_book_hotel">
              <div class="card-header book__accordion__header" id="headingTours">
                <!-- <h5 class="mb-0 mt-0 font-14">
                  <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="tours">
                    <i class="fas fa-map-marker-alt m-r-5"></i> Datos tours turístico
                  </a>
                  <div class="flex-30 flex-xs-100 m-l-10" style="display: inline-flex;">
                    <component-search-tour [classSize]="'search-small'" (selectedTourEvent)="selectedTourSearch($event)"
                      class="w-100"></component-search-tour>
                  </div>
                </h5> -->
                <div class="row">
                  <div class="col-lg-3 col-12">
                    <h5 class="mb-0 font-14 m-t-5">
                      <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="tours">
                        <i class="fas fa-map-marker-alt m-r-5"></i> Datos tours turístico
                      </a>
                    </h5>
                  </div>
                  <div class="col-lg-6 col-12">
                    <component-search-tour [classSize]="'search-small'" (selectedTourEvent)="selectedTourSearch($event)"
                      class="w-100"></component-search-tour>
                  </div>
                  <div class="col-lg-3 col-12" *ngIf="item.value.packagetour_id != null && !isEdit">
                    <a class="btn btn-sm btn-info m-l-10 f-s-10 bold text-white" (click)="importTourPackagetour()">
                      <i class="fas fa-level-down-alt m-r-2"></i> Tours de paquete
                    </a>
                  </div>
                </div>
              </div>
              <div id="tours" class="collapse show" aria-labelledby="headingTours" data-parent="#accordion">
                <div class="card-body p-l-15 p-r-15 p-t-10">
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0 table-sm">
                        <thead class="thead-default">
                          <tr>
                            <th class="text-center w-5">
                              <span class="f-s-9 text-center">
                                ¿Abierto?
                              </span>
                            </th>
                            <th class="text-left w-20">
                              Nombre tours
                            </th>
                            <th class="nowrap text-center w-10">Vehículo</th>
                            <th class="nowrap text-center w-10">Turno</th>
                            <th class="nowrap text-center w-10">N° pax
                              <span class="required-table">*</span>
                              <input type="text" class="text-center m-l-2" style="width: 25px; height: 20px;"
                                (keyup)="changeToursQuantityGeneral($event.target)" onclick="click_input(this)" numeric>
                            </th>
                            <th class="nowrap text-center w-10">Fecha <span class="required-table">*</span></th>
                            <th class="nowrap text-center">Observación</th>
                            <th class="nowrap text-center">Realizado</th>
                            <th class="text-center"></th>
                          </tr>
                        </thead>

                        <tbody>
                          <ng-container *ngIf="detail_tours.length == 0">
                            <tr>
                              <td colspan="4"><span>No se encontraron registros</span></td>
                            </tr>
                          </ng-container>
                          <ng-container *ngIf="detail_tours.length > 0">
                            <tr *ngFor="let item of detail_tours; let index_ = index"
                              [ngClass]="{'text-open': item.is_open}">
                              <td class="text-center w-5">
                                <ng-container *ngIf="!item.is_realized">
                                  <div class="input-group justify-content-center">
                                    <div class="input-group-prepend input-group-sm">
                                      <div class="custom-control custom-checkbox">
                                        <ng-container *ngIf="item.is_open">
                                          <input id="is_open{{index_}}" type="checkbox" class="custom-control-input"
                                            (change)="changeIsOpen(index_)" checked>
                                        </ng-container>
                                        <ng-container *ngIf="!item.is_open">
                                          <input id="is_open{{index_}}" type="checkbox" class="custom-control-input"
                                            (change)="changeIsOpen(index_)">
                                        </ng-container>
                                        <label class="custom-control-label p-t-3" for="is_open{{index_}}">
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                              </td>
                              <td class="text-left w-20">
                                {{item.description}}
                                <span *ngIf="item.is_open" class="m-l-5 f-s-9">(Estado abierto)</span>
                              </td>
                              <td class="nowrap text-center w-10 w-xs-20 w-xs-auto">
                                <select class="form-control sale__inputSelect" id="vehicleTourSelected{{index_}}"
                                  [disabled]="item.is_realized" (change)="changeVehicleTour($event.target, index_)">
                                </select>
                              </td>
                              <td class="nowrap text-center w-10">
                                <select class="form-control sale__inputSelect" id="shiftTourSelected{{index_}}"
                                  [disabled]="item.is_realized" (change)="changeShiftTour($event.target, index_)">
                                </select>
                              </td>
                              <td class="nowrap text-center w-10">
                                <input type="text" id="tours_quantity{{index_}}"
                                  class="form-control sale__input text-center" value="{{item.quantity}}"
                                  [disabled]="item.is_realized" (keyup)="changeToursQuantity($event.target, index_)"
                                  numeric onclick="click_input(this)">
                              </td>
                              <td class="nowrap text-center w-10">
                                <input type="text" class="form-control text-center sale__input f-s-12"
                                  id="date_assigned{{index_}}" [disabled]="item.is_realized || item.is_open"
                                  value="{{item.date_assigned}}">
                              </td>
                              <td class="nowrap text-center">
                                <input type="text" id="tours_observation{{index_}}"
                                  class="form-control sale__input f-s-11" value="{{item.observation}}"
                                  [disabled]="item.is_realized" (keyup)="changeToursObservation($event.target, index_)">
                              </td>
                              <td class="nowrap text-center">
                                <ng-container *ngIf="item.is_realized && item.date_realized == null">
                                  <span class="badge badge-info f-s-9">Asignado</span>
                                </ng-container>    
                                <span *ngIf="item.date_realized != null">{{item.date_realized}}</span>                            
                                <span *ngIf="item.date_realized == null">-</span>
                              </td>
                              <td class="text-center">
                                <i class="far fa-trash-alt book__trash"
                                  *ngIf="isEdit == true && item.is_realized == false"
                                  (click)="removeTour(item.id, index_)"></i>
                                <i class="far fa-trash-alt book__trash" *ngIf="isEdit == false"
                                  (click)="removeTour(item.id, index_)"></i>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-lg-12">
                      <hr style="height: 5px;" class="m-b-0 m-t-20">
                    </div>
                    <div class="form-group col-lg-6 col-12 m-t-10">
                      <label>Ubicación y referencias para recojo del turista <i class="fas fa-info-circle m-l-5"
                          uib-tooltip="Este campo es opcional si es que no se registra información de hotel, para el recojo de los tours del pasajero."></i></label>
                      <textarea rows="2" formControlName="reference_location"
                        class="form-control form-control-sm no-resize"></textarea>
                    </div>

                    <!-- <div class="row m-t-15">                      
                      <div class="form-group col-lg-6 col-12">
                        <div class="row justify-content-md-end m-t-15">
                          <div class="form-group col-lg-6">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <div class="input-group-text bold">T. HOTEL S/
                                  <span class="required-table"></span></div>
                              </div>
                              <input type="text" class="form-control form-control-sm text-right bold" id="total_hotels"
                                (keyup)="calculateTotal()" onclick="click_input(this)" formControlName="subtotal_hotel"
                                numeric decimals="2">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="col-lg-12 p-0">
                      <div class="row justify-content-md-end m-t-15">
                        <div class="form-group col-lg-3">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <div class="input-group-text bold">T. TOURS {{toolsService.momeySol()}} <span
                                  class="required-table"></span></div>
                            </div>
                            <input type="text" class="form-control form-control-sm text-right bold" id="total_tours"
                              (keyup)="calculateTotal()" onclick="click_input(this)" formControlName="subtotal_tour"
                              numeric decimals="2">
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0">
              <div class="card-header book__accordion__header" id="headingHotels">
                <h5 class="mb-0 mt-0 font-14">
                  <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="hotels">
                    <i class="fas fa-bed m-r-5"></i>Registro datos alojamiento
                  </a>
                  <a class="btn btn-sm btn-info m-l-10 f-s-10 bold text-white" id="add_book_hotel"
                    (click)="BookingsHotelExtendsComponent.loadData()" data-toggle="modal"
                    data-target="#openExtendsBookingHotel">Agregar Hotel
                    <i class="fas fa-plus m-l-2"></i>
                  </a>
                </h5>
              </div>
              <div id="hotels" class="collapse show" aria-labelledby="headingHotels" data-parent="#accordion">
                <div class="card-body p-l-15 p-r-15 p-t-10">
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0 table-sm">
                        <thead class="thead-default">
                          <tr>
                            <th>Nombre Hotel</th>
                            <th>Detalle Hab.</th>
                            <th>Deuda S/</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngIf="detail_hotels.length == 0">
                            <tr>
                              <td colspan="4"><span>No se encontraron registros</span></td>
                            </tr>
                          </ng-container>
                          <ng-container *ngIf="detail_hotels.length > 0">
                            <tr *ngFor="let item of detail_hotels; let index_ = index">
                              <td>
                                <span class="bold">{{item.tradename}}</span> ({{item.citietouristic}})
                                <p class="m-b-0 f-s-10">Cel: {{item.cellphone}}</p>
                              </td>
                              <td>
                                <div *ngFor="let bedroom of item.detail_bedrooms">
                                  <p class="m-b-0">{{bedroom.typebedroom}} <span class="f-s-11"> ({{bedroom.quantity}}
                                      hab. x {{bedroom.nights}} noches) </span></p>
                                  <span class="f-s-9 d-block m-b-5" style="font-weight: 600;"><i
                                      class="far fa-calendar-alt m-r-2"></i> {{bedroom.date_checkin}} -
                                    {{bedroom.date_checkout}}
                                    <span class="badge badge-success f-s-8 bold m-l-5" *ngIf="bedroom.is_paid">
                                      Reporte cuadre
                                    </span>
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span class="text-danger">{{toolsService.momeySol()}}{{item.total}}</span>
                              </td>
                              <td>
                                <a class="dropdown-item pointer" style="display: inline;" data-toggle="modal"
                                  data-target="#openExtendsBookingHotel"
                                  (click)="BookingsHotelExtendsComponent.editData(item, index_)">
                                  <i class="far fa-edit m-r-5 text-success"></i>Editar
                                </a>
                                <div class="btn-group mo-mb-2">
                                  <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-h"></i>
                                  </button>
                                  <div class="dropdown-menu" x-placement="bottom-start">
                                    <a class="dropdown-item pointer" (click)="removeDetailHotel(index_, item)">
                                      <i class="far fa-trash-alt m-r-5 text-danger"></i>Eliminar
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0" *ngIf="!item.value.is_book_hotel">
              <div class="card-header book__accordion__header" id="headingFlights">
                <h5 class="mb-0 mt-0 font-14">
                  <a class="collapsed book__accordion__title" data-parent="#accordion" aria-controls="flights">
                    <i class="fas fa-plane-departure m-r-5"></i>Registrar compra de vuelo
                  </a>
                </h5>
              </div>
              <div id="flights" class="collapse show" aria-labelledby="headingFlights" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10 p-t-10">
                  <div class="row m-t-15">
                    <div class="form-group col-lg-4 col-12">
                      <label>Información ticket</label>
                      <ng-container *ngIf="item.value.url_file_flight != null">
                        <div class="row col-lg-12 col-12 p-0">
                          <div class="col-lg-8 col-6">
                            <a target="_blank" href="tenants/{{item.value.url_file_flight}}"
                              class="btn btn-outline-primary pointer w-100 f-s-12">Archivo cargado <i
                                class="far fa-file-pdf m-l-5"></i></a>
                          </div>
                          <div class="form-group col-lg-4 col-6">
                            <button (click)="removeFilePdfFlight()" class="btn btn-outline-danger pointer w-100 f-s-11">
                              Quitar <i class="fas fa-minus-circle"></i>
                            </button>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="item.value.url_file_flight == null">
                        <input id="file_pdf" type="file" class="form-control" (change)="onFileSelectedFlight($event)"
                          accept="application/pdf" />
                      </ng-container>
                    </div>
                    <div class="form-group col-lg-2 col-12">
                      <label>Monto compra S/</label>
                      <input type="text" class="form-control" formControlName="subtotal_flight" numeric decimals="2"
                        onclick="click_input(this)">
                    </div>
                    <div class="form-group col-lg-6 col-12">
                      <label>Observaciones de vuelo </label>
                      <textarea rows="1" formControlName="register_flight"
                        placeholder="Consideraciones a tomar en cuenta"
                        class="form-control form-control-sm no-resize"></textarea>
                    </div>
                    <!-- <div class="form-group col-lg-6 col-12">
                      <div class="row justify-content-md-end m-t-15">
                        <div class="form-group col-lg-6">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <div class="input-group-text bold">T. VUELO S/.
                                <span class="required-table"></span></div>
                            </div>
                            <input type="text" class="form-control form-control-sm text-right bold" id="total_flights"
                              ng-click="click_total_flights(this)" ng-change="changeTotalFlights(total_flights)"
                              ng-model="total_flights">
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!--summary paid booking-->

            <div class="card mb-0 book__summary">
              <div class="col-lg-12">
                <ng-container *ngIf="!isEdit">
                  <div class="row justify-content-md-center">
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold text-primary">TOTAL RESERVA S/</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right bold text-primary f-s-14"
                          id="total_tours" onclick="click_input(this)" formControlName="total" numeric decimals="2">
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="isEdit">
                  <div class="row justify-content-md-end">
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold text-primary">T.RESERVA {{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right bold text-primary f-s-14"
                          id="total_tours" onclick="click_input(this)" formControlName="total" numeric decimals="2">
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold f-s-12">PAGADO {{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right bold f-s-14"
                          id="total_paid" numeric decimals="2" disabled value="{{item.value.total_paid}}">
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text text-danger bold f-s-12">S.PENDIENTE {{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right text-danger bold f-s-14"
                          id="total_paid" numeric decimals="2" disabled value="{{(item.value.total - item.value.total_paid).toFixed(2)}}">
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div class="text-right m-t-15" *ngIf="isEdit && item.dirty">
                  <span class="badge badge-info">Clic en "Guardar Cambios" para registra los cambios realizados</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-lg-12 form__footerBtn btns-fixeds p-l-0 p-r-0 ">
            <div class="text-right">
              <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
              <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                <i class="far fa-save m-r-5"></i>
                Guardar
                <ng-container *ngIf="isEdit">
                  Cambios
                </ng-container>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
<app-bookings-hotel-extends (onSubmitEvent)="extendsBookingHotel($event)"></app-bookings-hotel-extends>
